import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const AddTabPage = () => {
  const { tabId } = useParams();
  const navigate = useNavigate();

  const [getTabName, setTabName] = useState("");
    const [getTabSlag, setTabSlag] = useState("");

  // =========================
  // FETCH SINGLE Tab
  // =========================
  const fetchTabById = async () => {
    try {
      const res = await api.get(`/adminHolidays/get-holidays-tab-by-id/${tabId}`);

      if (res.data.success) {
        const data = res.data.data;
        setTabName(data.name);
        setTabSlag(data.slug);

      } else {
        toast.error("Tab not found");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch Tab");
    }
  };

  useEffect(() => {
    if (tabId) {
      fetchTabById();
    }
  }, [tabId]);


useEffect(() => {
  const slugData = getTabName
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

  setTabSlag(slugData);
}, [getTabName]);

  // =========================
  // UPDATE Tab
  // =========================
 const updateTab = async () => {
  // =========================================
  // VALIDATION
  // =========================================

  if (!getTabName || !getTabName.trim()) {
    toast.error("Tab name required");
    return;
  }

  if (!getTabSlag || !getTabSlag.trim()) {
    toast.error("Tab slug required");
    return;
  }

  // =========================================
  // CONFIRMATION
  // =========================================

  const confirm = await Swal.fire({
    title: "Update Tab?",
    text: "Are you sure you want to update this tab?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes Update",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    return;
  }

  try {
    // =========================================
    // PAYLOAD
    // =========================================

    const payload = {
      tab_id: tabId,
      name: getTabName.trim(),
      slug: getTabSlag.trim(),
    };

    console.log("UPDATE TAB PAYLOAD =>", payload);

    // =========================================
    // API CALL
    // =========================================

    const res = await api.put(
      `/adminHolidays/holidays-update-tab/${tabId}`,
      payload
    );

    console.log("UPDATE TAB RESPONSE =>", res.data);

    // =========================================
    // SUCCESS
    // =========================================

    if (res.data?.success) {
      await Swal.fire({
        title: "Success",
        text: res.data.message || "Tab Updated Successfully",
        icon: "success",
      });

      navigate("/holidays/tabs/manage-tabs");
    } else {
      Swal.fire({
        title: "Error",
        text: res.data?.message || "Failed to update tab",
        icon: "error",
      });
    }

  } catch (error) {
    console.error("UPDATE TAB ERROR =>", error);

    toast.error(
      error?.response?.data?.message ||
      "Server Error"
    );
  }
};

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between">
          <h4>Edit Tab</h4>

          <Link to="/holidays/tabs/manage-tabs" className="btn btn-secondary btn-sm">
            <ArrowLeft size={16} /> Back
          </Link>
        </div>
      </div>

      {/* FORM */}
      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
              </tr>
            </thead>

            <tbody>

                <tr >
                  <td>
                    <input
                      className="form-control"
                      value={getTabName}
                      onChange={(e) =>
                        setTabName(e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      readOnly
                      value={getTabSlag}
                      onChange={(e) =>
                        setTabSlag(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
            
            
     

          </table>

          <button className="btn btn-success mt-3" onClick={updateTab}>
            Update Tab
          </button>

        </div>
      </div>
    </div>
  );
};

export default AddTabPage;